// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"42ad8476","365":"2069edd8","396":"12833897","453":"8c264ca1","473":"185bba0f","492":"bb49e95f","628":"d6e6a328","805":"7918b019","828":"44b555ca"}[chunkId] + ".chunk.js";
};